import React from 'react';
import { useSelector } from 'react-redux';
import CreatableSelect from 'react-select/creatable';

import { Form, Select, DatePicker } from 'ui/components';
import { SkeletonsForm } from 'ui/components/skeleton';

import { formatDate } from 'utilities/common';
import _ from 'underscore'

const TermOfPayment = [
  { value: 7, label: '7 Hari' },
  { value: 14, label: '14 Hari' },
  { value: 21, label: '21 Hari' },
  { value: 30, label: '30 Hari' },
  { value: 45, label: '45 Hari' },
];

const initialState = {
  optionsEmails: null,
  ref_code: '',
  customer: null,
  project: null,
  term_of_payment: null,
  periode_project_at: {
    default: new Date(),
    formatted: formatDate(new Date(), 'YYYY-MM'),
  },
  billing_address: null,
};

export const FormGeneral = ({
  data,
  onChange,
  isLoading
}) => {
  const StateForm = useSelector((state) => state?.Form);
  const [
    {
      ref_code,
      optionsEmails,
      customer,
      project,
      term_of_payment,
      periode_project_at,
      billing_to,
      billing_address,
    },
    setState,
  ] = React.useState(initialState);

  const dummy = Array.from({ length: 4 }, (v, i) => i);

  const $handleCustomer = async (e) => {
    let oe = []
    if (e?.finance_emails) {
      _.each(e?.finance_emails, (i) => {
        oe.push({label: i, value: i})
      })
    }

    if(e?.pic_email) {
      oe.push({label: e?.pic_email, value: e?.pic_email})
    }

    setState((prevState) => ({
      ...prevState,
      customer: e,
      billing_address: e?.address,
      project: null,
      optionsEmails: oe
    }));
  };

  const $handleProject = async (e) => {
    let top = null
    _.each(TermOfPayment, (t) => {
      if (t?.value === e?.top) {
        top = t
      }
    })

    setState((prevState) => ({
      ...prevState,
      project: e,
      term_of_payment: top,
    }));
  };

  const $handlePeriodeProject = async(e) => {
    setState((prevState) => ({
      ...prevState,
      periode_project_at: { default: e, formatted: formatDate(e, 'YYYY-MM') },
    }));
  }

  const $handleTermOfPayment = async (e) => {
    setState((prevState) => ({
      ...prevState,
      term_of_payment: e,
    }));
  };


  React.useEffect(() => {
    let emails = []

    _.each(optionsEmails, (i) => {
      emails.push(i?.label)
    })

    const state = {
      ref_code,
      emails,
      customer,
      project,
      term_of_payment,
      periode_project_at,
      billing_to,
      billing_address,
    };

    onChange(state);
  }, [
    ref_code,
    optionsEmails,
    customer,
    project,
    term_of_payment,
    periode_project_at,
    billing_to,
    billing_address,
  ]);

  React.useEffect(() => {
    if (!data) return;

    let top = null
    _.each(TermOfPayment, (t) => {
      if (t?.value === data?.term_of_payment) {
        top = t
      }
    })

    let oe = []
    if (data?.emails) {
      _.each(data?.emails, (i) => {
        oe.push({label: i, value: i})
      })
    }

    setState((prevState) => ({
      ...prevState,
      ref_code: data?.ref_code,
      optionsEmails: oe,
      customer: data?.customer,
      project: data?.project,
      term_of_payment: data?.term_of_payment > 0 ? top : null,
      periode_project_at: {
        default: new Date(data?.periode_project),
        formatted: formatDate(data?.periode_project, 'YYYY-MM'),
      },
      billing_to: data?.billing_to,
      billing_address: data?.billing_address,
    }));
  }, [data]);

  return (
    <div className='mt-3 border-bottom'>
      {isLoading ? (
        <div className="row border-bottom">
          {dummy?.map((d, i) => (
            <div className="col-md-6" key={i}>
              <SkeletonsForm count={1} />
            </div>
          ))}
        </div>
      ) : (
        <div className='row'>
          <div className='col-6'>
            <Form.Input
              label="No. Referensi"
              type="text"
              value={ref_code}
              onChange={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  ref_code: e.target.value,
                }))
              }
              error={StateForm?.errors?.ref_code}
            />
            <div className="mb-3">
              <Select.Remote
                required
                label="Pilih Customer"
                placeholder=""
                url="/partner"
                params={{'type': 'customer', 'search': customer ? customer?.name: ''}}
                initialValue={customer?.id}
                keys={customer?.id}
                row={(d) => {
                  return { value: d.id, label: d.name };
                }}
                onSelected={(c) => {
                  $handleCustomer(c);
                }}
                errors={StateForm?.errors?.customer_id}
              />
            </div>
            {customer && (
              <div className="mb-3">
                <Select.Remote
                  required
                  label="Pilih Project"
                  placeholder=""
                  url="/project"
                  params={{'status': 'active', 'customer_id': customer?.id, 'search': project ? project?.name: ''}}
                  initialValue={project?.id}
                  keys={project?.id || customer?.id}
                  row={(d) => {
                    return { value: d.id, label: d.name };
                  }}
                  onSelected={(c) => {
                    $handleProject(c);
                  }}
                  errors={StateForm?.errors?.project_id}
                  disabled={!customer}
                />
              </div>
            )}

            <Form.Textbox
              label="Alamat Penagihan"
              required
              type="text"
              value={billing_address || ' '}
              onChange={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  billing_address: e.target.value,
                }))
              }
              error={StateForm?.errors?.billing_address}
            />

          </div>
          <div className='col-6'>
            <div className="mb-3">
              <label className='form-label'>Email</label>
              <CreatableSelect
                value={optionsEmails}
                classNamePrefix={StateForm?.errors?.emails ? 'is-invalid_multi' : 'select_multi'}
                placeholder="Enter Emails"
                style={{backgroundColor: 'rgba(42,255,0,0.3 )'}}
                className="bg-white"
                isMulti
                onChange={(e) =>
                  setState((prevState) => ({
                    ...prevState,
                    optionsEmails: e,
                  }))
                }
              />

              {StateForm?.errors?.emails ? (
                <div className="invalid-feedback" style={{ display: 'block' }}>
                  {StateForm?.errors?.emails}
                </div>
              ) : null}
            </div>

            <div className="mb-3">
              <label className="form-label required">Periode Project</label>
              <div
                className={
                  StateForm?.errors?.periode_project_at
                    ? 'border border-danger rounded'
                    : ''
                }
              >
                <DatePicker
                  selectionMode="month"
                  value={periode_project_at?.default || null}
                  format="yyyy/MM"
                  onChange={(date) => {
                    $handlePeriodeProject(date);
                  }}
                  isShowTrigger
                  error={StateForm?.errors?.periode_project_at}
                />
              </div>

              {StateForm?.errors?.periode_project_at ? (
                <div className="invalid-feedback" style={{ display: 'block' }}>
                  {StateForm?.errors?.periode_project_at}
                </div>
              ) : null}
            </div>

            <div className="mb-3">
              <label className="form-label required">Pilih Ketentuan Pembayaran</label>
              <Select
                isClearable
                classNamePrefix={
                  StateForm?.errors?.term_of_payment
                    ? 'is-invalid'
                    : 'select'
                  }
                placeholder=""
                value={term_of_payment}
                options={TermOfPayment}
                onChange={(e) => $handleTermOfPayment(e)}
                error={StateForm?.errors?.term_of_payment}
              />

              {StateForm?.errors?.term_of_payment ? (
                <div className="invalid-feedback" style={{ display: 'block' }}>
                  {StateForm?.errors?.term_of_payment}
                </div>
              ) : null}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
